import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'
import { queryClient } from '../../../App'
import { getNewServiceOrders } from '../../../services/NewApiService'
import { CheckboxStore } from '../../../stores/CheckboxStore'
import NewPaginationStore from '../../../stores/NewPaginationStore'
import { getComp } from '../../../utils/utils/DI'

const initParams: ParamsType = {}
export const singleMaintenanceReportPaginationStore = new NewPaginationStore(
  initParams,
)

export const singleMaintenanceReportCheckboxStore = new CheckboxStore()

export const useSingleServiceReportTableData = (reportId: number) => {
  const renderRef = useRef(false)
  const {
    page,
    size,
    sort,
    setScrollHeight,
    params: {
      fullAddress,
      dateOfMaintenanceFrom,
      dateOfMaintenanceTo,
      fullName,
      id,
      phoneNumber,
      statuses,
      dataCheckingStatuses,
      ticketStatuses,
    },
    setPage,
  } = singleMaintenanceReportPaginationStore

  useEffect(() => {
    if (renderRef.current) {
      setPage(0)
      setScrollHeight(0)
    } else {
      renderRef.current = true
    }
  }, [
    fullAddress,
    dateOfMaintenanceFrom,
    dateOfMaintenanceTo,
    fullName,
    id,
    phoneNumber,
    statuses,
    dataCheckingStatuses,
    ticketStatuses,
  ])

  const userId = getComp('UserInfoStore')?.info?.id

  return useQuery(
    {
      queryKey: [
        'single-service-report-table',
        size,
        page,
        sort,
        fullAddress,
        dateOfMaintenanceFrom,
        dateOfMaintenanceTo,
        fullName,
        id,
        phoneNumber,
        statuses,
        dataCheckingStatuses,
        ticketStatuses,
        userId,
        reportId,
      ],
      queryFn: () =>
        getNewServiceOrders({
          size,
          page,
          fullAddress,
          dateOfMaintenanceFrom,
          dateOfMaintenanceTo,
          fullName,
          id,
          phoneNumber,
          statuses,
          sort: sort ?? undefined,
          dataCheckingStatuses,
          ticketStatuses,
          reportId,
        }),
      staleTime: 1000000,
      placeholderData: keepPreviousData,
      enabled: () => !!userId && !!reportId,
    },
    queryClient,
  )
}

export type ParamsType = {
  id?: string
  phoneNumber?: string
  dateOfMaintenanceFrom?: string
  dateOfMaintenanceTo?: string
  fullName?: string
  fullAddress?: string
  statuses?: number[]
  dataCheckingStatuses?: number[]
  ticketStatuses?: number[]
}
